import { render } from "./EpisodeCommentsWidget.vue.js?vue&type=template&id=62324f9c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeCommentsWidget.vue?vue&type=template&id=62324f9c"
import script from "./EpisodeCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeCommentsWidget.vue?vue&type=script&lang=js"
export * from "./EpisodeCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeCommentsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/episode-page/EpisodeCommentsWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62324f9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62324f9c', __exports__)) {
    api.reload('62324f9c', __exports__)
  }
  
  module.hot.accept("./EpisodeCommentsWidget.vue.js?vue&type=template&id=62324f9c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeCommentsWidget.vue?vue&type=template&id=62324f9c", () => {
    api.rerender('62324f9c', render)
  })

}


export default __exports__